 import React from "react";
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const { t } = useTranslation();
  let d = new Date();
  return (
    <div className={`footer ${props.changeFooter}`}>
      <div className="copyright">
        <p className="tw-text-gray-500 dark:tw-text-gray-300">
          Copyright © {t("footer.designedBy")}{" "}
          <a href="https://www.mdscresoft-group.com/" target="_blank" rel="noreferrer" className="tw-text-[var(--primary)]">
            MDSCRESOFT-Group
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
